import { Modal } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import CloseIcon from "../icons/ico-close.svg";
import DownloadIcon from "../icons/download.svg";
import { Button } from "./Button";
import { LightCheckbox } from "./LightCheckbox";
import { ndaAgreement } from "./ndaAgreementText";

const ndaUrl = `${process.env.S3_PUBLIC_DOCUMENTS_ROOT_URL}docs/NDA.pdf`;

type NdaModalProps = {
  open: boolean;
  onClose?: () => void;
  onUpdateNdaAgreement: () => void;
  ndaChecked?: boolean;
};

export const NdaModal = ({
  open,
  onClose,
  ndaChecked,
  onUpdateNdaAgreement,
}: NdaModalProps) => {
  const [agreed, setAgreed] = useState(false);

  const handleOnChangeNdaCheckbox = () => {
    if (!agreed) {
      setAgreed(true);
      onUpdateNdaAgreement();
    }
  };

  useEffect(() => {
    if (ndaChecked !== agreed) {
      setAgreed(ndaChecked);
    }
  }, [ndaChecked]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      closable={false}
      footer={null}
      width={600}
      centered
      className="tailwind-modal-document-preview"
    >
      <div className="p-[28px] flex justify-between items-center">
        <h2 className="text-xl font-semibold mb-0 pl-[23px]">
          Confidentiality and Non-Disclosure Agreement
        </h2>

        <div className="cursor-pointer h-[16px]" onClick={onClose}>
          <CloseIcon />
        </div>
      </div>
      <div
        className="h-full max-h-[60vh] overflow-y-auto border-t border-b py-[20px] px-[50px] bg-grey-light border-grey-lighter"
        dangerouslySetInnerHTML={{ __html: ndaAgreement }}
      />

      <div className="flex justify-between items-center gap-2 py-[28px] px-[50px]">
        <LightCheckbox
          checked={agreed}
          onChange={handleOnChangeNdaCheckbox}
          label="I accept the agreement"
        />

        <Button
          href={ndaUrl}
          download={true}
          className="h-[42px] flex gap-2 items-center"
        >
          Download <DownloadIcon />
        </Button>
      </div>
    </Modal>
  );
};
